export const THEMES = {
  terminal: {
    name: 'Terminal',
    bg: '#0a0e14',
    bgElev: '#0f141c',
    bgHover: '#161c26',
    border: '#1f2733',
    borderStrong: '#2a3441',
    text: '#e6edf3',
    muted: '#8b96a8',
    faint: '#5a6678',
    up: '#2ea043',
    upSoft: 'rgba(46,160,67,0.12)',
    down: '#f85149',
    downSoft: 'rgba(248,81,73,0.12)',
    warn: '#d29922',
    accent: '#58a6ff',
    accentSoft: 'rgba(88,166,255,0.10)',
    cardBg: '#0f141c',
    inputBg: '#161c26',
    tagBg: '#1f2733',
    tagText: '#8b96a8',
    swatch1: '#0f141c',
    swatch2: '#2ea043',
  },
  light: {
    name: 'Light',
    bg: '#f8f9fb',
    bgElev: '#ffffff',
    bgHover: '#f0f2f5',
    border: '#e1e5eb',
    borderStrong: '#c8cdd6',
    text: '#1a1d23',
    muted: '#5a6275',
    faint: '#9299a8',
    up: '#1a7a32',
    upSoft: 'rgba(26,122,50,0.10)',
    down: '#c0392b',
    downSoft: 'rgba(192,57,43,0.10)',
    warn: '#b8860b',
    accent: '#1a6bbf',
    accentSoft: 'rgba(26,107,191,0.09)',
    cardBg: '#ffffff',
    inputBg: '#ffffff',
    tagBg: '#e8ecf2',
    tagText: '#4a5268',
    swatch1: '#ffffff',
    swatch2: '#1a6bbf',
  },
  sage: {
    name: 'Sage',
    bg: '#f0f7f2',
    bgElev: '#ffffff',
    bgHover: '#e4f0e8',
    border: '#c5deca',
    borderStrong: '#a8ccb0',
    text: '#1a2e1e',
    muted: '#4a6e54',
    faint: '#7fa88a',
    up: '#1a6b2e',
    upSoft: 'rgba(26,107,46,0.12)',
    down: '#b53a2a',
    downSoft: 'rgba(181,58,42,0.10)',
    warn: '#8a6b10',
    accent: '#2a7a4e',
    accentSoft: 'rgba(42,122,78,0.12)',
    cardBg: '#ffffff',
    inputBg: '#ffffff',
    tagBg: '#d4ebda',
    tagText: '#2a5e36',
    swatch1: '#f0f7f2',
    swatch2: '#2a7a4e',
  },
};

export function applyTheme(t) {
  const r = document.documentElement.style;
  r.setProperty('--bg',           t.bg);
  r.setProperty('--bg-elev',      t.bgElev);
  r.setProperty('--bg-hover',     t.bgHover);
  r.setProperty('--border',       t.border);
  r.setProperty('--border-strong',t.borderStrong);
  r.setProperty('--text',         t.text);
  r.setProperty('--muted',        t.muted);
  r.setProperty('--faint',        t.faint);
  r.setProperty('--up',           t.up);
  r.setProperty('--up-soft',      t.upSoft);
  r.setProperty('--down',         t.down);
  r.setProperty('--down-soft',    t.downSoft);
  r.setProperty('--warn',         t.warn);
  r.setProperty('--accent',       t.accent);
  r.setProperty('--accent-soft',  t.accentSoft);
}
